export default {"src":"/_next/static/media/download-app-mobile-hand.2a03d1ea.svg","height":500,"width":284,"blurWidth":0,"blurHeight":0};